import { HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
export class ParametrosService {
    constructor() { }
    getToken() {
        return new HttpHeaders({
            enctype: 'multipart/form-data',
            Authorization: 'Bearer ' + localStorage.getItem('autenticacion_token')
        });
    }
    postToken() {
        return new HttpHeaders({
            'Content-Type': 'application/json; charset=utf8',
            Authorization: 'Bearer ' + localStorage.getItem('autenticacion_token')
        });
    }
    FormDataToken() {
        return new HttpHeaders({
            enctype: 'multipart/form-data',
            Authorization: 'Bearer ' + localStorage.getItem('autenticacion_token')
        });
    }
    ContentTypeToken() {
        return new HttpHeaders({
            'Content-Type': 'application/json; charset=utf8',
            Authorization: 'Bearer ' + localStorage.getItem('autenticacion_token')
        });
    }
    infoDatos(res) {
        let body = res;
        return body.info || {};
    }
}
ParametrosService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ParametrosService_Factory() { return new ParametrosService(); }, token: ParametrosService, providedIn: "root" });
